import { NavigationGuard } from "vue-router"

export { ressourceGuard, adminRessourceGuard }

const ressourceGuard: NavigationGuard = async (to, from, next) =>  {
  document.title = "삼성화재";

  const cssFiles = ["common.css"];

  const devUrl = "scraping-apidev.tobecon.io";
  const prdUrl = "scraping-api.tobecon.io";

  const baseUrl =
      process.env.NODE_ENV === "production"
          ? `https://${window.location.host.includes("sandbox") ?
            devUrl : prdUrl}/samsungfireobesity/css/css/` :
            `http://localhost:5127/samsungfireobesity/css/css/`;

  const loadCss = (css: string): Promise<void> => {
      return new Promise((resolve, reject) => {
          const link = document.createElement("link");
          link.rel = "stylesheet";
          link.href = `${baseUrl}${css}`;
          link.onload = () => resolve();
          link.onerror = () => reject(new Error(`Failed to load CSS: ${css}`)); // 로드 실패 시 reject 호출
          document.head.appendChild(link);
      });
  };

  try {
      await Promise.all(cssFiles.map(loadCss));
      next();
  } catch (error) {
      console.error(error);
      next(false);
  }
}

const adminRessourceGuard: NavigationGuard = async (to, from, next) =>  {
  document.title = "삼성화재";

  const cssFiles = ["common.css", "reset.css"];

  const devUrl = "scraping-apidev.tobecon.io";
  const prdUrl = "scraping-api.tobecon.io";

  const baseUrl =
      process.env.NODE_ENV === "production"
          ? `https://${window.location.host.includes("sandbox") ?
            devUrl : prdUrl}/samsungfireadmin/css/` :
            `http://localhost:5127/samsungfireadmin/css/`;

  const loadCss = (css: string): Promise<void> => {
      return new Promise((resolve, reject) => {
          const link = document.createElement("link");
          link.rel = "stylesheet";
          link.href = `${baseUrl}${css}`;
          link.onload = () => resolve();
          link.onerror = () => reject(new Error(`Failed to load CSS: ${css}`)); // 로드 실패 시 reject 호출
          document.head.appendChild(link);
      });
  };

  try {
      await Promise.all(cssFiles.map(loadCss));
      next();
  } catch (error) {
      console.error(error);
      next(false);
  }
}